"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var useTime = function (initialSeconds, step, intervalDuration) {
    if (step === void 0) { step = 1000; }
    if (intervalDuration === void 0) { intervalDuration = 1000; }
    var _a = react_1["default"].useState(false), isActive = _a[0], setIsActive = _a[1];
    var _b = react_1["default"].useState(initialSeconds * 1000), miliseconds = _b[0], setMiliseconds = _b[1];
    var start = react_1["default"].useCallback(function () {
        setMiliseconds(initialSeconds * 1000);
        setIsActive(true);
    }, [initialSeconds]);
    var stop = react_1["default"].useCallback(function () {
        setMiliseconds(0);
        setIsActive(false);
    }, []);
    react_1["default"].useEffect(function () {
        var interval = undefined;
        if (isActive && miliseconds !== 0) {
            interval = setInterval(function () {
                setMiliseconds(function (miliseconds) { return miliseconds - step; });
            }, intervalDuration);
        }
        else if (!isActive) {
            clearInterval(interval);
        }
        else {
            stop();
        }
        return function () { return clearInterval(interval); };
    }, [isActive, miliseconds, step, intervalDuration, stop]);
    return [start, stop, miliseconds, isActive];
};
exports["default"] = useTime;
